var map = {
  "./shape-heart-aquamarine-light.png": "415421",
  "./shape-heart-aquamarine.png": "378760",
  "./shape-heart-blue-gradient.png": "157971",
  "./shape-heart-blue-light.png": "389752",
  "./shape-heart-blue.png": "644406",
  "./shape-heart-cyan-gradient-1.png": "20339",
  "./shape-heart-cyan-gradient.png": "58133",
  "./shape-heart-cyan-light.png": "299481",
  "./shape-heart-cyan.png": "945075",
  "./shape-heart-green-gradient.png": "231498",
  "./shape-heart-green-light.png": "725081",
  "./shape-heart-green.png": "135394",
  "./shape-heart-grey100.png": "66316",
  "./shape-heart-grey1000.png": "793658",
  "./shape-heart-grey200.png": "345887",
  "./shape-heart-grey25.png": "619027",
  "./shape-heart-grey300.png": "141312",
  "./shape-heart-grey400.png": "122147",
  "./shape-heart-grey50.png": "65945",
  "./shape-heart-grey500.png": "320020",
  "./shape-heart-grey600.png": "637555",
  "./shape-heart-grey700.png": "861672",
  "./shape-heart-grey800.png": "99890",
  "./shape-heart-grey900.png": "110438",
  "./shape-heart-indigo-gradient.png": "18521",
  "./shape-heart-indigo-light.png": "569047",
  "./shape-heart-indigo.png": "843480",
  "./shape-heart-lime-gradient.png": "207890",
  "./shape-heart-lime-light.png": "140691",
  "./shape-heart-lime.png": "969620",
  "./shape-heart-magenta-gradient.png": "850479",
  "./shape-heart-magenta-light.png": "348092",
  "./shape-heart-magenta.png": "331339",
  "./shape-heart-navy-gradient.png": "298877",
  "./shape-heart-navy-light.png": "618648",
  "./shape-heart-navy.png": "678678",
  "./shape-heart-orange-gradient.png": "208952",
  "./shape-heart-orange-light.png": "680750",
  "./shape-heart-orange.png": "949913",
  "./shape-heart-purple-gradient.png": "38069",
  "./shape-heart-purple-light.png": "473443",
  "./shape-heart-purple.png": "480205",
  "./shape-heart-red-gradient.png": "739639",
  "./shape-heart-red-light.png": "586364",
  "./shape-heart-red.png": "76831",
  "./shape-heart-yellow-gradient.png": "239761",
  "./shape-heart-yellow-light.png": "8405",
  "./shape-heart-yellow.png": "52827"
};


function webpackContext(req) {
  var id = webpackContextResolve(req);
  return __webpack_require__(id);
}
function webpackContextResolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
webpackContext.keys = function webpackContextKeys() {
  return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 397899;
